// Shared styles for menu items (used by MenuItem and HelpPopoverTrigger)
export const MENU_ITEM_STYLES = {
  PADDING: '6px 16px',
  GAP: '12px',
  BORDER_RADIUS: '12px',
  ICON_SIZE: '20px',
  TRANSITION_DURATION: '300ms',
  TEXT_FONT_SIZE: '16px',
} as const

// Layout styles for menu containers
export const MENU_CONTAINER_STYLES = {
  PADDING_TOP: '26px', // Custom spacing for visual separation between profile header and menu actions
  PADDING_X: '6px', // Horizontal padding for menu items container
} as const

// Help popover styles
export const HELP_POPOVER_STYLES = {
  WIDTH: '280px',
  PADDING_Y: '16px',
  BORDER_RADIUS: '16px',
  Z_INDEX: 1500,
  HORIZONTAL_OFFSET: 8,
} as const

export const PROFILE_POPOVER_STYLES = {
  WIDTH: '300px',
  PADDING_Y: '16px',
  BORDER_RADIUS: '16px',
  MARGIN_BOTTOM: '2',
  HEADER_PADDING_X: '18px',
  HEADER_GAP: '16px',
  AVATAR_SIZE: '48px',
  AVATAR_FONT_SIZE: '14px',
  AVATAR_FONT_WEIGHT: 700,
  NAME_FONT_SIZE: '16px',
  ROLE_FONT_SIZE: '14px',
  ROLE_MARGIN_TOP: '4px',
  CLICK_OUTSIDE_DELAY: 100,
} as const

export const SUPPORT_LINKS = {
  EMAIL: 'mailto:support@hivewatch.zendesk.com',
  KNOWLEDGE_BASE: 'https://hivewatch.zendesk.com/hc/en-us',
} as const
